var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('a-spin',{staticClass:"loading"},[_c('a-icon',{staticClass:"icon",attrs:{"slot":"indicator","type":"loading"},slot:"indicator"})],1):_c('transition',{attrs:{"name":"router"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }